<ion-row class="warningBorderMargin marginAuto h-100" tabindex="0" (click)="navigateUnroadworthyDefects()"
  (keydown.enter)="navigateUnroadworthyDefects()">
  <!-- Left warning icon -->
  <ion-col size-xl="3.5" size-xs="1.5" class="d-flex justify-content-end align-items-center">
    <ion-icon class="warningIcon" src="assets/imgs/holman/warning-triangle.svg">
    </ion-icon>
  </ion-col>

  <ion-col size-xl="5" size-xs="9" class="d-flex flex-column align-items-center" [ngClass]="
    {
      'mobile-text':isMobileApp,
      'font-sm': !isMobileApp
    }">
    <span class="orangeText font-family-bold text-center">
      {{ 'ROADWORTHY_DEFECTS_STATUS_DISPLAY' | translate }}
    </span>

    <span class="dark-color text-center">
      @if (checkBookingPermission()) {
      {{ 'CALL_HOLMAN_MESSAGE2' | translate }}
      }
      @else {
      {{ 'CALL_HOLMAN_MESSAGE3' | translate }}
      }
    </span>
  </ion-col>

  <!-- Right navigation icon -->
  <ion-col size-xl="3.5" size-xs="1.5" class="d-flex justify-content-start align-items-center">
    <ion-icon class="warningIcon" src="assets/imgs/holman/menu-orange.svg">
    </ion-icon>
  </ion-col>
</ion-row>